import { ACTION_TYPES } from 'src/constants';
import { INITIAL_STATE } from '../store';

export default function CheckoutReducer(state = INITIAL_STATE.checkout, action) {
  switch (action.type) {
    case ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_SUCCESS:
      return {
        ...state,
        checkoutDetail: { ...action.payload },
      };

    case ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SUCCESS:
      return {
        ...state,
        checkoutPayment: { ...action.payload },
      };

    case ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SIP_SUCCESS:
      return {
        ...state,
        checkoutPaymentSip: { ...action.payload },
      };

    default:
      return state;
  }
}
